import { useGameStore } from '../store';

interface Step {
  mode: 'blocking' | 'hint';
  title: string;
  body: string;
  btnLabel: string;
}

const STEPS: Record<number, Step> = {
  0: {
    mode: 'blocking',
    title: '청산에 살어리랏다',
    body: '레버리지 야수의 세계에 오신 것을 환영합니다.\n\n5,000만냥으로 시작하여 종목을 사재기하고 물량풀기해 재산을 불리세요.\n레버리지를 높이면 수익도, 청산도 빠릅니다.',
    btnLabel: '사재기 해보기',
  },
  1: {
    mode: 'hint',
    title: '사재기',
    body: '사재기 버튼을 눌러 매수하세요.',
    btnLabel: '',
  },
  2: {
    mode: 'hint',
    title: '물량풀기',
    body: '올랐습니다! 물량풀기 버튼을 눌러 매도하세요.',
    btnLabel: '',
  },
  3: {
    mode: 'blocking',
    title: '강제청산이란?',
    body: '잔액 + 포지션 평가액이 0이 되면\n강제청산이 발생합니다.\n\n레버리지가 높을수록 작은 하락에도 청산됩니다.\n반대로 수익도 배율로 불어납니다.',
    btnLabel: '이해했습니다',
  },
  4: {
    mode: 'blocking',
    title: '준비 완료!',
    body: '이제 야수처럼 거래하세요.\n사또 청원(광고)으로 긴급 냥을 수령하고,\n노역으로 부수입도 챙기세요.\n\n야수의 왕좌를 노려보시오!',
    btnLabel: '시작하겠습니다',
  },
};

export default function TutorialOverlay() {
  const tutStep     = useGameStore((s) => s.tutStep);
  const setTutStep  = useGameStore((s) => s.setTutStep);
  const endTutorial = useGameStore((s) => s.endTutorial);

  const step = STEPS[tutStep];
  if (!step) return null;

  const isHint = step.mode === 'hint';

  const handleBtn = () => {
    if (tutStep === 4) endTutorial();
    else setTutStep(tutStep + 1);
  };

  return (
    <div
      id="tut-overlay"
      className={step.mode}
      style={isHint ? { pointerEvents: 'none' } : undefined}
    >
      <div id="tut-box">
        <div id="tut-title">{step.title}</div>
        <div id="tut-body">{step.body}</div>
        {step.btnLabel && (
          <button id="tut-btn" onClick={handleBtn}>
            {step.btnLabel}
          </button>
        )}
      </div>
    </div>
  );
}
